<template>
    <div>
        <div class="app" v-if="loading">
            <div class="app-body app flex-row align-items-center">
                <main class="main">
                    <div class="container-fluid">
                        <div class="row justify-content-center">
                            <loading message="Аларм План запускается..."></loading>
                        </div>
                    </div>
                </main>
            </div>
        </div>
      <div class="app" v-else>
        <template v-if="$route.meta.isIframe">
          <div class="app-body m-0 mt-2">
            <main class="main m-0">
              <div class="container-fluid">
                <router-view></router-view>
              </div>
            </main>
          </div>
        </template>
        <template v-else>
          <AppHeader/>
          <div class="app-body">
            <Sidebar/>
            <main class="main">
              <breadcrumb :list="list"/>
              <div class="container-fluid">
                <router-view></router-view>
              </div>
            </main>
          </div>
          <AppFooter/>
        </template>

        <ModalCloseOrder/>
        <ModalCancelOrder/>
        <ModalProblemOrder/>
        <ModalTransitionOrderConfirm/>
        <ModalEditOrder/>
        <ModalAdminAddUser/>
        <ModalAdminAddEditCity/>
        <ModalAdminAddEditCompany/>
        <ModalAdminAddEditRole/>
        <ModalAdminAddEditVirtualNumber/>
        <ModalsOrdersStatisticParams/>
        <ModalAdminAddEditInternalNumber/>
        <ModalUpdatePage/>
      </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import AppHeader from '../components/Header'
  import Sidebar from '../components/Sidebar'
  import AppFooter from '../components/Footer'
  import Breadcrumb from '../components/Breadcrumb'
  import ModalCloseOrder from '../components/Modals/ModalCloseOrder'
  import ModalCancelOrder from '../components/Modals/ModalCancelOrder'
  import ModalProblemOrder from '../components/Modals/ModalProblemOrder'
  import ModalTransitionOrderConfirm from '../components/Modals/ModalTransitionOrderConfirm.vue'
  import ModalEditOrder from '../components/Modals/ModalEditOrder'
  import ModalAdminAddUser from '../components/Modals/ModalAdminAddUser'
  import ModalAdminAddEditCity from '../components/Modals/ModalAdminAddEditCity.vue'
  import ModalAdminAddEditCompany from '../components/Modals/ModalAdminAddEditCompany.vue'
  import ModalAdminAddEditRole from '../components/Modals/ModalAdminAddEditRole.vue'
  import ModalAdminAddEditTechcenter from '../components/Modals/ModalAdminAddEditTechcenter.vue'
  import ModalAdminAddEditVirtualNumber from '../components/Modals/ModalAdminAddEditVirtualNumber.vue'
  import ModalAdminAddEditInternalNumber from '../components/Modals/ModalAdminAddEditInternalNumber.vue'
  import ModalsOrdersStatisticParams from '../components/Modals/ModalsOrdersStatisticParams.vue'
  import ModalUpdatePage from '../components/Modals/ModalUpdatePage.vue'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import { getHeader } from './../config'
  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppFooter,
      Breadcrumb,
      ModalCloseOrder,
      ModalCancelOrder,
      ModalProblemOrder,
      ModalTransitionOrderConfirm,
      ModalEditOrder,
      ModalAdminAddUser,
      ModalAdminAddEditCity,
      ModalAdminAddEditCompany,
      ModalAdminAddEditRole,
      ModalAdminAddEditTechcenter,
      ModalsOrdersStatisticParams,
      ModalAdminAddEditVirtualNumber,
      ModalAdminAddEditInternalNumber,
      ModalUpdatePage
    },
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched
      },
      ...mapState({
        loading: state => state.globalStore.loadingApp,
        user: state => state.globalStore.user,
        activeOrderId: state => state.orderStore.activeOrderId,
        orders: state => state.orderStore.orders
      })
    },
    methods: {
      newCommentEventListner (comment) {
        let text = comment.user.fullname + ' добавил комментарий к заказу №' + comment.orderId + ': ' + comment.text
        this.addToast({
          text: text,
          type: 'info',
          dismissAfter: 10000
        })
        if (this.activeOrderId === comment.orderId) {
          this.$store.commit('ADD_COMMENT', {
            id: comment.id,
            diffForHumans: comment.diffForHumans,
            text: comment.text,
            date: comment.date,
            time: comment.time,
            user: {
              id: comment.user.id,
              fullname: comment.user.fullname,
              avatar: comment.user.avatar
            }
          })
          setTimeout(() => {
            this.$store.dispatch('markAsViewed', comment.orderId)
          }, 2000)
        }
        this.$store.commit('COMMENT_HAS_BEEN_ADDED', comment)
        this.$store.commit('COMMENT_HAS_BEEN_UNVIEWED', comment)
      },
      changeStatusEventListner (order, notification, user) {
        let text = user.fullname + ' изменил статус заказа №' + order.id + ' на ' + order.status.name
        this.addToast({
          text: text,
          type: 'info',
          dismissAfter: 10000
        })
        this.$store.commit('UPDATE_ORDER', order)
        if (notification) {
          this.$store.commit('ADD_NOTIFICATION_FIRST', notification)
        }
      },
      updateOrderEventListner (orderId, user) {
        this.$store.dispatch('updateOrderStoreById', orderId).then((order) => {
          let text = user + ' изменил заказ №' + order.id
          this.addToast({
            text: text,
            type: 'success',
            dismissAfter: 10000
          })
        })
      },
      phoneVisibleEventListner (orderId) {
        let filteredOrders = this.orders.filter(order => {
          return order.id === orderId && order.clientPhone === '**********'
        })
        if (filteredOrders.length > 0) {
          this.$store.dispatch('updateOrderStoreById', orderId).then((order) => {
            let text = 'Доступен к просмотру номер телефона по заказу №' + order.id
            this.addToast({
              text: text,
              type: 'success',
              dismissAfter: 10000
            })
          })
        }
      },
      updateOrderStateEventListner (orderId, user) {
        this.$store.dispatch('updateOrderStoreById', orderId).then((order) => {
          let text = user + ' изменил статус заказа №' + order.id + ' на ' + order.status.name
          this.addToast({
            text: text,
            type: 'success',
            dismissAfter: 10000
          })
        })
      },
      updateOrderProblemEventListner (orderId, user, problem) {
        this.$store.dispatch('updateOrderStoreById', orderId).then((order) => {
          if (problem) {
            let text = user + ' пометил заказ №' + order.id + ' как проблемный'
            this.addToast({
              text: text,
              type: 'danger',
              dismissAfter: 10000
            })
          } else {
            let text = user + ' решил проблему с заказом №' + order.id
            this.addToast({
              text: text,
              type: 'success',
              dismissAfter: 10000
            })
          }
        })
      },
      updateOrderCancelEventListner (orderId, user, cancel) {
        this.$store.dispatch('updateOrderStoreById', orderId).then((order) => {
          if (cancel) {
            let text = user + ' отменил заказ №' + order.id
            this.addToast({
              text: text,
              type: 'danger',
              dismissAfter: 10000
            })
          } else {
            let text = user + ' снял отмену заказа №' + order.id
            this.addToast({
              text: text,
              type: 'success',
              dismissAfter: 10000
            })
          }
        })
      },
      deleteOrderEventListner (orderId, user) {
        let text = user + ' удалил заказ №' + orderId
        this.addToast({
          text: text,
          type: 'danger',
          dismissAfter: 10000
        })
        this.$store.commit('DELETE_ORDER', orderId)
      },
      addedNewOrderEventListner (orderId, user) {
        this.$store.dispatch('addOrderStoreById', orderId).then((order) => {
          let text = user + ' добавил новый заказ №' + order.id
          this.addToast({
            text: text,
            type: 'success',
            dismissAfter: 10000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.$store.dispatch('initApp').then(() => {
        this.$echo.options.auth.headers = getHeader()
        this.$echo.private('user.' + this.user.id)
          .listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (event) => {
            if (event.updateNotification) {
              this.$store.dispatch('updateNotifications')
            }
            switch (event.type) {
              case 'App\\Notifications\\Orders\\User\\CommentAdded':
                this.newCommentEventListner(event.comment)
                break
              case 'App\\Notifications\\Orders\\User\\OrderStatusHasBeenChanged':
                this.changeStatusEventListner(event.order, event.notification, event.user)
                break
              case 'App\\Notifications\\Orders\\User\\OrderHasBeenChanged':
                this.updateOrderEventListner(event.orderId, event.user)
                break
              case 'App\\Notifications\\Orders\\User\\OrderHasBeenDeleted':
                this.deleteOrderEventListner(event.orderId, event.user)
                break
              case 'App\\Notifications\\Orders\\User\\AddedNewOrderNotification':
                this.addedNewOrderEventListner(event.orderId, event.user)
                break
              case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedProblem':
                this.updateOrderProblemEventListner(event.orderId, event.user, event.problem)
                break
              case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedCancel':
                this.updateOrderCancelEventListner(event.orderId, event.user, event.cancel)
                break
              case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedState':
                this.updateOrderStateEventListner(event.orderId, event.user)
                break
              case 'App\\Notifications\\Orders\\User\\PhoneIsVisible':
                this.phoneVisibleEventListner(event.orderId)
                break
              default:
                console.log(event)
            }
          })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Full.vue?582dccca